import * as React from 'react';
import { HeaderContext } from '@core-front/header-provider';
const Affix = (props) => {
    const { className, children, } = props;
    const referenceElement = React.useRef(null);
    const [affixHeight, setAffixHeight] = React.useState(0);
    const [windowsHeight, setWindowsHeight] = React.useState(0);
    const { headerHeight, isHeaderHidden, headerBottomHeight } = React.useContext(HeaderContext);
    React.useEffect(() => {
        setAffixHeight(referenceElement.current && /* istanbul ignore next */ referenceElement.current.clientHeight || 0);
    }, [referenceElement]);
    React.useEffect(() => {
        const resizeListener = () => {
            setWindowsHeight(window.innerHeight - headerHeight - (isHeaderHidden ? headerBottomHeight : 0));
        };
        window.addEventListener('resize', resizeListener);
        resizeListener();
        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, [headerHeight, isHeaderHidden, headerBottomHeight]);
    const BEM = () => {
        const classArray = ['affix'];
        if (className) {
            classArray.push(className);
        }
        if (affixHeight > windowsHeight) {
            classArray.push('affix--static');
        }
        return classArray.join(' ');
    };
    const getStyle = () => {
        const inModal = referenceElement.current && /* istanbul ignore next */ referenceElement.current.closest('.modal') !== null;
        return {
            top: inModal ? 0 : headerHeight - (isHeaderHidden ? headerBottomHeight : 0),
        };
    };
    return (React.createElement("div", { ref: referenceElement, className: BEM(), style: getStyle(), "aria-hidden": props['aria-hidden'] }, children));
};
export { Affix as default, };
